import { Order, OrderType } from '@getvim-os/types';
import { v4 as uuid } from 'uuid';
import { encounterIdA } from '../encounters';

export const orderD: Order = {
  id: uuid(),
  type: OrderType.LAB,
  icd: [{ name: 'Transsexualism', code: 'F64.0' }],
  cpts: [
    {
      name: 'Adjacent tissue transfer or rearrangement, trunk; defect 10 sq cm or less',
      code: '14000',
    },
  ],
  encounterId: encounterIdA,
  createdDate: '2000-01-01',
};
